// Client-side navigation for the manual pathname router in App.tsx. Pushes a
// history entry and notifies the router (which listens for `app:navigate` and
// `popstate`) so the view re-renders without a full reload.
export function navigateTo(path: string): void {
  if (typeof window === 'undefined') {
    return
  }
  window.history.pushState({}, '', path)
  window.dispatchEvent(new Event('app:navigate'))
}
